import React from "react";
import { Table } from "react-bootstrap";
import moment from "moment";

const formatKcal = (value) =>
  value === null || value === undefined
    ? "-"
    : `${Number(value).toLocaleString()} kcal`;

const balanceClassName = (balance) => {
  if (balance === null || balance === undefined) return "";
  return balance < 0 ? "over" : "under";
};

const ManualActivityCalorieTable = ({ rows }) => {
  if (!rows || rows.length === 0) {
    return <div className="no-result text-center">No data available</div>;
  }

  return (
    <Table
      className="metric-table calorie-grid"
      style={{ borderRadius: "8px", overflow: "hidden" }}
    >
      <thead>
        <tr>
          <th className="date-col">Date</th>
          <th>Consumed</th>
          <th>Target</th>
          <th>Burned</th>
          <th>Balance</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.date} className="metric-row">
            <td className="metric-label">
              {moment(row.date).format("DD-MM-YYYY")}
            </td>
            <td>{formatKcal(row.consumed)}</td>
            <td>{formatKcal(row.target)}</td>
            <td>{formatKcal(row.burned)}</td>
            <td className={`balance-cell ${balanceClassName(row.balance)}`}>
              {formatKcal(row.balance)}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default React.memo(ManualActivityCalorieTable);
